import React from "react";
import { Button, makeStyles, tokens } from "@fluentui/react-components";
import { Checkmark24Regular } from "@fluentui/react-icons";

const useStyles = makeStyles({
    tabGroup: {
        display: "flex",
        gap: "8px",
        width: "100%",
    },
    tabButton: {
        flex: "1",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "6px",
    },
    checkmark: {
        color: tokens.colorPaletteGreenForeground1,
    },
});

interface DifficultyTabsProps {
    numberCount: 4 | 5 | 6;
    completionStatus: { [key: number]: boolean };
    isCompleted: boolean;
    onNumberCountChange: (count: 4 | 5 | 6) => void;
}

export function DifficultyTabs({
    numberCount,
    completionStatus,
    isCompleted,
    onNumberCountChange,
}: DifficultyTabsProps) {
    const styles = useStyles();

    return (
        <div className={styles.tabGroup}>
            <Button
                appearance={numberCount === 4 ? "primary" : "secondary"}
                size="large"
                onClick={() => onNumberCountChange(4)}
                className={styles.tabButton}
                disabled={isCompleted && numberCount === 4}
            >
                {completionStatus[4] ? (
                    <Checkmark24Regular className={styles.checkmark} />
                ) : (
                    "4"
                )}
            </Button>
            <Button
                appearance={numberCount === 5 ? "primary" : "secondary"}
                size="large"
                onClick={() => onNumberCountChange(5)}
                className={styles.tabButton}
                disabled={isCompleted && numberCount === 5}
            >
                {completionStatus[5] ? (
                    <Checkmark24Regular className={styles.checkmark} />
                ) : (
                    "5"
                )}
            </Button>
            <Button
                appearance={numberCount === 6 ? "primary" : "secondary"}
                size="large"
                onClick={() => onNumberCountChange(6)}
                className={styles.tabButton}
                disabled={isCompleted && numberCount === 6}
            >
                {completionStatus[6] ? (
                    <Checkmark24Regular className={styles.checkmark} />
                ) : (
                    "6"
                )}
            </Button>
        </div>
    );
}
